var change = "Ändern";
var edit = "Bearbeiten";
var loading = "Wird geladen";
var logout = "Ausloggen";
var support = "Online Hilfe";
var more = "Mehr";
var yes = "Jawohl";
var no = "Nein";
var exit = "Ausgang";
var you = "Du";
var search = "Suchen";
var de = {
	"business-unit": "Geschäftsbereich",
	"ces-administration": "CES-Verwaltung",
	change: change,
	"change-business-unit": "Geschäftsbereich wechseln",
	edit: edit,
	loading: loading,
	logout: logout,
	"no-application-available": "Keine Anwendung verfügbar.",
	"select-a-business-unit-to-change": "Wählen Sie eine Geschäftseinheit aus, zu der Sie wechseln möchten. Wenn die Geschäftseinheit Ihre aktuelle Bewerbung nicht nutzt, werden Sie zu Ihrem Profil weitergeleitet.",
	support: support,
	"system-administration": "Systemadministration",
	more: more,
	yes: yes,
	no: no,
	"you-already-switched-to": "Sie sind bereits vor einiger Zeit zu <bold>{{name}}</bold> gewechselt. Möchten Sie <bold>{{name}}</bold> hier umschalten?",
	"business-unit-has-changed": "Der Geschäftsbereich hat sich geändert",
	exit: exit,
	"impersonated-user": "Imitierter Benutzer",
	you: you,
	"no-business-unit-assigned": "Kein Geschäftsbereich zugeordnet",
	"explore-marigold": "Entdecken Marigold",
	"no-data-to-display": "Keine Daten zum Anzeigen",
	search: search
};

export { change, de as default, edit, exit, loading, logout, more, no, search, support, yes, you };
